import React from 'react';
import styled from 'styled-components';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import breakpoint from 'styled-components-breakpoint';
import IconPeople from './assets/icon-people.svg';
import IconCards from './assets/icon-cards.svg';
import IconStar from './assets/icon-star.svg';

const BackgroundWrapper = styled.div`
  padding: 75px 0 92px 0;
  margin-top: 92px;
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;

  &::before {
    content: '';
    width: 100%;
    height: 573px;
    background-color: #f8f8f8;
    position: absolute;
    z-index: -1;
    top: -3px;
    display: none;
  }

  ${breakpoint('desktop')`
    &::before {
      display: block;
    }
  `};
`;

const Info = styled.div`
  text-align: left;
  width: 865px;
  max-width: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  ${breakpoint('tablet')`
    padding: 0;
  `};
`;

const InfoTitle = styled.h2`
  font-weight: 700;
  font-size: 28px;
  line-height: 36px;
  color: #333333;
  margin-bottom: 11px;
  padding: 0 20px;

  & > span > span {
    color: #2756f5;
  }

  ${breakpoint('tablet')`
    font-size: 46px;
    line-height: 50px;
    letter-spacing: 1.1px;
    padding: 0;
  `};
`;

const InfoSubtitle = styled.p`
  font-weight: 400;
  font-size: 23px;
  line-height: 30px;
  letter-spacing: 0.5px;
  color: #000000;
  margin-bottom: 72px;
  padding: 0 20px;

  ${breakpoint('tablet')`
    padding: 0;
  `};
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${breakpoint('desktop')`
    justify-content: center;
    flex-direction: row;
  `};
`;

const Card = styled.div`
  min-width: 259px;
  width: 260px;
  min-height: 237px;
  height: 237px;
  border-radius: 50px;
  background-color: #fff;
  padding: 33px 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #dbdbdb;
  &:not(:last-of-type) {
    margin-bottom: 50px;
  }

  ${breakpoint('desktop')`
    margin-bottom: 0 !important;
    &:not(:last-of-type) {
      margin-right: 44px;
    }
  `};
`;

const Title = styled.h3`
  font-weight: 700;
  font-size: 26px;
  line-height: 34px;
  letter-spacing: 1px;
  color: #333333;
  margin-bottom: 4px;
`;

const Subtitle = styled.p`
  font-weight: 400;
  font-size: 23px;
  line-height: 30px;
  letter-spacing: 0.5px;
  color: #333333;
  text-align: center;
`;

const Icon = styled.i`
  width: 77px;
  min-width: 77px;
  height: 66px;
  min-height: 66px;
  background: #e8eefd;
  border-radius: 19px;
  display: block;
  position: relative;
  margin-bottom: 12px;

  &.icon-star {
    &:before {
      background-image: url(${IconStar});
      width: 52px;
      height: 52px;
    }
  }
  &.icon-people {
    &:before {
      background-image: url(${IconPeople});
      width: 59px;
      height: 39px;
    }
  }
  &.icon-cards {
    &:before {
      background-image: url(${IconCards});
      width: 39px;
      height: 39px;
    }
  }

  &:before {
    content: '';
    background-repeat: no-repeat;
    background-size: cover;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
  }
`;

const ReputationCards = () => {
  return (
    <BackgroundWrapper>
      <Info>
        <InfoTitle>
          <FormattedHTMLMessage
            id="homeredesign.reputationcards.infotitle"
            defaultMessage="<span>999.md</span> - крупнейшая площадка"
          />
        </InfoTitle>
        <InfoSubtitle>
          <FormattedMessage
            id="homeredesign.reputationcards.infosubtitle"
            defaultMessage="в Молдове для продаж в интернете"
          />
        </InfoSubtitle>
      </Info>
      <Wrapper>
        <Card>
          <Icon className="icon-star" />
          <Title>
            <FormattedMessage
              id="homeredesign.reputationcards.title1"
              defaultMessage="20 лет"
            />
          </Title>
          <Subtitle>
            <FormattedMessage
              id="homeredesign.reputationcards.subtitle1"
              defaultMessage="на рынке Молдовы"
            />
          </Subtitle>
        </Card>
        <Card>
          <Icon className="icon-people" />
          <Title>
            <FormattedMessage
              id="homeredesign.reputationcards.title2"
              defaultMessage="3 миллиона"
            />
          </Title>
          <Subtitle>
            <FormattedHTMLMessage
              id="homeredesign.reputationcards.subtitle2"
              defaultMessage="пользователей<br />в год"
            />
          </Subtitle>
        </Card>
        <Card>
          <Icon className="icon-cards" />
          <Title>100 000</Title>
          <Subtitle>
            <FormattedMessage
              id="homeredesign.reputationcards.subtitle3"
              defaultMessage="объявлений ежедневно"
            />
          </Subtitle>
        </Card>
      </Wrapper>
    </BackgroundWrapper>
  );
};

export default ReputationCards;
